import { apiInstance } from '@/api/api.js'
import moment from 'moment'

const api = apiInstance()

export default {
  async getJourneys({ commit, dispatch }, { profileId }) {
    try {
      commit('setLoading', true)
      const url = `/profiles/${profileId}/journeys`
      const response = await api.get(url)
      commit('setJourneys', response.data.content)
      commit('setLoading', false)
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async generateJourney(
    { commit, dispatch },
    {
      profileId,
      title,
      duration,
      journalFrequency,
      heroicChoiceFrequency,
      positiveActionsFrequency,
      messageTime,
      courseSteps,
      description,
    },
  ) {
    try {
      commit('setLoading', true)
      const url = `/profiles/${profileId}/journeys/generate`
      const response = await api.post(url, {
        title,
        duration,
        journalFrequency,
        heroicChoiceFrequency,
        positiveActionsFrequency,
        messageTime,
        courseSteps,
        description,
      })
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Journey is generating!', {
        root: true,
      })
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async getJourney(
    { commit, dispatch },
    { profileId, journeyId, silent = false },
  ) {
    try {
      if (!silent) {
        commit('setLoading', true)
      }
      const url = `/profiles/${profileId}/journeys/${journeyId}`
      const response = await api.get(url)
      commit('setJourney', response.data)
      if (!silent) {
        commit('setLoading', false)
      }
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async acceptJourney(
    { commit, dispatch },
    { profileId, journeyId, startDate },
  ) {
    try {
      commit('setLoading', true)
      const url = `/profiles/${profileId}/journeys/${journeyId}/accept`
      const response = await api.post(url, { startDate })
      commit('setLoading', false)
      //   commit('resetJourney')
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async regenerateAllPositiveActionsJourney(
    { commit, dispatch },
    { profileId, journeyId },
  ) {
    try {
      commit('setLoading', true)
      const url = `/profiles/${profileId}/journeys/${journeyId}/positive-actions/regenerate`
      const response = await api.post(url)
      commit('setLoading', false)
      commit(
        'appStates/setSnackbarNotification',
        'Positive actions regenerated!',
        {
          root: true,
        },
      )
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async regenerateAllTimedMessagesJourney(
    { commit, dispatch },
    { profileId, journeyId },
  ) {
    try {
      commit('setLoading', true)
      const url = `/profiles/${profileId}/journeys/${journeyId}/timed-messages/regenerate`
      const response = await api.post(url)
      commit('setLoading', false)
      commit(
        'appStates/setSnackbarNotification',
        'Timed messages regenerated!',
        {
          root: true,
        },
      )
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async regenerateAllCoursesJourney(
    { commit, dispatch },
    { profileId, journeyId },
  ) {
    try {
      commit('setLoading', true)
      const url = `/profiles/${profileId}/journeys/${journeyId}/courses/regenerate`
      const response = await api.post(url)
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Course regenerated!', {
        root: true,
      })
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async regeneratePositiveActionsJourney(
    { commit, dispatch },
    { profileId, journeyId, positiveActionId },
  ) {
    try {
      commit('setLoading', true)
      const url = `/profiles/${profileId}/journeys/${journeyId}/positive-actions/${positiveActionId}/regenerate`
      const response = await api.post(url)
      commit('setLoading', false)
      commit(
        'appStates/setSnackbarNotification',
        'Positive action regenerated!',
        {
          root: true,
        },
      )
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async regenerateTimedMessagesJourney(
    { commit, dispatch },
    { profileId, journeyId, timedMessageId },
  ) {
    try {
      commit('setLoading', true)
      const url = `/profiles/${profileId}/journeys/${journeyId}/timed-messages/${timedMessageId}/regenerate`
      const response = await api.post(url)
      commit('setLoading', false)
      commit(
        'appStates/setSnackbarNotification',
        'Timed message regenerated!',
        {
          root: true,
        },
      )
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async regenerateCoursesLessonJourney(
    { commit, dispatch },
    { profileId, journeyId, courseId, lessonId },
  ) {
    try {
      commit('setLoading', true)
      const url = `/profiles/${profileId}/journeys/${journeyId}/courses/${courseId}/lessons/${lessonId}/regenerate`
      const response = await api.post(url)
      commit('setLoading', false)
      commit(
        'appStates/setSnackbarNotification',
        'Course lesson regenerated!',
        {
          root: true,
        },
      )
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async updatePositiveActionsJourney(
    { commit, dispatch },
    { profileId, journeyId, positiveActionId, title, description, time },
  ) {
    try {
      commit('setLoading', true)
      const url = `/profiles/${profileId}/journeys/${journeyId}/positive-actions/${positiveActionId}`
      const response = await api.put(url, {
        title,
        description,
        time,
      })
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Positive action updated!', {
        root: true,
      })
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async updateTimedMessagesJourney(
    { commit, dispatch },
    { profileId, journeyId, timedMessageId, day, message, time },
  ) {
    try {
      commit('setLoading', true)
      const url = `/profiles/${profileId}/journeys/${journeyId}/timed-messages/${timedMessageId}`
      const response = await api.put(url, {
        day,
        message,
        time,
      })
      commit('appStates/setSnackbarNotification', 'Timed message updated!', {
        root: true,
      })
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async updateCoursesLessonJourney(
    { commit, dispatch },
    { profileId, journeyId, courseId, lessonId, title, description, order },
  ) {
    try {
      commit('setLoading', true)
      const url = `/profiles/${profileId}/journeys/${journeyId}/courses/${courseId}/lessons/${lessonId}`
      const response = await api.put(url, {
        title,
        description,
        order,
      })
      commit('appStates/setSnackbarNotification', 'Courses lesson updated!', {
        root: true,
      })
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },

  async generateJourneyPdf({ commit, dispatch }, { profileId, journeyId }) {
    try {
      commit('setLoading', true)
      const url = `/profiles/${profileId}/journeys/${journeyId}/generate-pdf`
      const response = await api.post(url, null, {
        responseType: 'blob',
      })

      // Handle stream response
      if (response.data) {
        const generatedTime = moment().format('YYYY-MM-DD h-mm-ss a')
        const blob = new Blob([response.data], {
          type: 'application/pdf;',
        })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `GeneratedJourney-${generatedTime}.pdf`
        link.click()
        URL.revokeObjectURL(link.href)
      }

      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Journey PDF generated!', {
        root: true,
      })
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
      return error
    }
  },
}
